import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#1B4D40] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">
              Green Coke and Energy
            </h3>
            <p className="text-sm text-gray-300 mb-4 lg:w-[70%]">
              Premium Metallurgical Coke and Green Energy solutions for
              industrial excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
                >
                  About Us
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/products"
                  className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
                >
                  Products & Services
                </Link>
              </li> */}
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <a href="tel:+919176651276">
                  <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                </a>
                <span>
                  <a href="tel:+919176651276">+919176651276</a>
                </span>
              </li>

              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <a href="mailto:info@greencokeenergy.com">
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                </a>
                <span>
                  <a href="mailto:info@greencokeenergy.com">
                    {companyInfo.contact.emails.general}
                  </a>
                </span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>
                  {'Chennai'}, {'Tamil Nadu'}
                </span>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href={"#"}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-lg hover:bg-[#C0D8A3] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href={"#"}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-lg hover:bg-[#C0D8A3] transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href={"#"}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-lg hover:bg-[#C0D8A3] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-300">
              © 2025 Green Coke and Energy Pvt. Ltd. All Rights Reserved.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/legal"
                className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/legal"
                className="text-sm text-gray-300 hover:text-[#C0D8A3] transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;